/**
 * DIEUKYDIEU.TV - SEARCH GLOBAL EVENTS & KEYBOARD SHORTCUTS
 */
import {
    closeDesktopSearchDropdown,
    closeMobileSearch,
    openMobileSearch,
    handleDesktopSearchFocus,
    viewAllSearchResults
} from '../search.js';

let desktopActiveIndex = -1;
export function setDesktopActiveIndex(idx) { desktopActiveIndex = idx; }

export function initSearchEvents() {
    try {
        const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
        const modEl = document.querySelector('.kbd-mod');
        if (modEl && isMac) {
            modEl.textContent = '⌘';
        }
    } catch (e) {}

    // Click outside Desktop Dropdown listener
    document.addEventListener('click', (e) => {
        const wrap = document.getElementById('header-search-wrapper');
        const res = document.getElementById('desktop-search-results');
        if (res && res.classList.contains('show')) {
            if (wrap && !wrap.contains(e.target) && !res.contains(e.target)) {
                closeDesktopSearchDropdown();
            }
        }
    });

    // Global Esc and Ctrl+K / Cmd+K listener
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeDesktopSearchDropdown();
            closeMobileSearch();
            const deskInput = document.getElementById('desktop-search-input');
            if (deskInput) deskInput.blur();
        }

        if ((e.ctrlKey || e.metaKey) && (e.key === 'k' || e.key === 'K')) {
            e.preventDefault();
            if (window.innerWidth >= 768) {
                const deskInput = document.getElementById('desktop-search-input');
                if (deskInput) {
                    deskInput.focus();
                    deskInput.select();
                    handleDesktopSearchFocus();
                }
            } else {
                openMobileSearch();
            }
        }
    });

    // Keyboard navigation in Desktop search input
    const desktopInputEl = document.getElementById('desktop-search-input');
    if (desktopInputEl) {
        desktopInputEl.addEventListener('keydown', (e) => {
            const resultsBox = document.getElementById('desktop-search-results');
            if (!resultsBox || !resultsBox.classList.contains('show')) return;

            const selectableItems = resultsBox.querySelectorAll('.media-row-card, .search-history-item, .search-dropdown-footer');
            if (selectableItems.length === 0) return;

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                desktopActiveIndex = (desktopActiveIndex + 1) % selectableItems.length;
                selectableItems.forEach((el, idx) => el.classList.toggle('keyboard-focused', idx === desktopActiveIndex));
                if (selectableItems[desktopActiveIndex]) {
                    selectableItems[desktopActiveIndex].scrollIntoView({ block: 'nearest' });
                }
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                desktopActiveIndex = (desktopActiveIndex - 1 + selectableItems.length) % selectableItems.length;
                selectableItems.forEach((el, idx) => el.classList.toggle('keyboard-focused', idx === desktopActiveIndex));
                if (selectableItems[desktopActiveIndex]) {
                    selectableItems[desktopActiveIndex].scrollIntoView({ block: 'nearest' });
                }
            } else if (e.key === 'Enter') {
                e.preventDefault();
                if (desktopActiveIndex >= 0 && selectableItems[desktopActiveIndex]) {
                    selectableItems[desktopActiveIndex].click();
                } else if (desktopInputEl.value.trim().length > 0) {
                    viewAllSearchResults(desktopInputEl.value.trim(), false);
                }
            }
        });
    }
}
